import React, { Component } from 'react'
import 'react-vertical-timeline-component/style.min.css';
// import ScrollAnimation from 'react-animate-on-scroll';
import './Timeline.css'

class Education extends Component{
    render(){
        return(
            <section id="id2">
                <div className="divTimeline">
                    {/* <h1 style={{textAlign: 'center',  fontSize: '28px'}}><u>ACADEMICS INFO</u></h1> */}
                    <section id="timeline">
                        <article>
                            <div className="inner">
                                <span className="date"><i className="fa fa-graduation-cap fa-lg" style={{fontSize: '35px'}}></i></span>
                                <div className="innerInner">
                                    <h2>B.Tech in Computer Science and Engineering</h2>
                                    <p><h3>B.P.Poddar Institute of Management and Technology</h3>Studied the core subjects including Engineering Mathematics, C Language, Chemistry, Electrical and Electronics and Physics</p>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className="inner">
                                <span className="date"><i className="fa fa-home fa-lg" style={{fontSize: '35px'}}></i></span>
                                <div className="innerInner">
                                    <h2>AISSCE (2019)</h2>
                                    <p><h3>Kendriya Vidyalaya Cossipore</h3>Studied subjects are Physics, Chemistry, Mathematics, Biology </p>
                                </div>
                            </div>
                        </article>
                        <article>
                            <div className="inner">
                                <span className="date"><i className="fa fa-home fa-lg" style={{fontSize: '35px'}}></i></span>
                                <div className="innerInner">
                                    <h2>Secondary Education (2017)</h2>
                                    <p><h3>Kendriya Vidyalaya Cossipore</h3>Studied Science, Hindi, English, Social Science, and Mathematics</p>
                                </div>
                            </div>
                        </article>
                    </section>
                </div>
            </section>
        )
    }
}
export default Education;